import React from 'react'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'
import IntroSection from '../../components/IntroSection'
import { introdata, blogdata } from '../../content_option'
import { useBlogPosts } from '../../hooks/useBlogPosts'
import { formatDate } from '../../utils/dateUtils'

const CATEGORIES = ['life', 'tech']

export const Blog = () => {
  const { posts, loading, error } = useBlogPosts()

  const typewriterStrings = [
    blogdata.description.first,
    blogdata.description.second,
    blogdata.description.third,
  ]

  const renderContent = () => {
    if (loading) return <p className="loading">Loading posts...</p>
    if (error) return <p className="error">Error loading posts: {error}</p>

    return <div>{CATEGORIES.map((cat) => {
      const catPosts = posts.filter((p) => p.category === cat).slice(0, 3)
      return (
        <div key={cat} className="mb-1x">
          <Link
            className="d-flex flex-column item mt-4"
            to={`/blog/${cat}`}
            style={{ textTransform: 'capitalize' }}
          >
            <div className="post" style={{ fontWeight: 700 }}>{cat}</div>
          </Link>
          <ul className="list" style={{ paddingLeft: '1rem' }}>
            {catPosts.map((post) => (
              <li key={post.slug}>
                <Link className="d-flex flex-column item mt-2" to={`/blog/${post.slug}`}>
                  <div style={{ fontSize: '15px' }}>{post.title}</div>
                  <div className="date" style={{ fontSize: '11px' }}>{formatDate(post.date)}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )
    })}</div>
  }

  return (
    <PageLayout title="Blog" id="blog" className="blog">
      <IntroSection
        title={introdata.title}
        titleLink="/"
        backgroundImage={blogdata.img_url}
        typewriterStrings={typewriterStrings}
      >
        {renderContent()}
      </IntroSection>
    </PageLayout>
  )
}
